/**
 * 放水记录路由
 */
const TuanReleaseRouter = {
  path: 'tuanRelease',
  name: 'TuanRelease',
  meta: {
    requiresAuth: false,
    leftMenu: true          // false表示不需要左边菜单栏
  },
  component: () => import('@/views/TuanRelease/index')
}
export default TuanReleaseRouter
